// extracted by mini-css-extract-plugin
export default {"tableStyles":"TimeShareEleTable_tableStyles__0lwwq","title":"TimeShareEleTable_title__TjXtm"};